<template>
    <section class="pda-default">
        <div v-if="orderData.paymentPrice === 0">
            <div class="t-headline5 mgt-3">
                {{$t('901')}}
                <!-- 과거에 수강신청했던 강의입니다 -->
            </div>
            <div class="t-body3 mt6 t-color-content1">
                {{$t('902')}}
                <!-- 이미 동일한 강의를 수강신청하신 이력이 있습니다.-->
                <br>
                {{$t('903')}}
                <!-- 수강신청 내역은 아래와 같습니다. -->
            </div>

            <div class="mdc-card mdc-elevation--z3 mgt-16">
                <div class="t-subtitle2 pdt-16 pdl-16 pdr-16">
                    {{$t('904')}}
                    <!-- 과거 수강신청한 강의 정보 -->
                </div>

                <div v-for="(purchased, index) in purchasedData" :key="index">
                    <div class="pda-default">
                        <div class="t-body3">
                            <div class="t-color-content1">
                                {{$t('905')}}
                                <!-- 강의명 -->
                            </div>
                            <div>{{orderData.goods.name}}</div>
                        </div>
                        <div class="t-body3 mgt-17">
                            <div class="t-color-content1">
                                {{$t('906')}}
                                <!-- {{paymentText}} 일자 -->
                            </div>
                            <div>{{$moment(purchased.orderDate).format('L')}}</div>
                        </div>
                    </div>
                    <div v-if="purchasedData.length-1 > index"><hr class="divider"></div>
                    

                </div>
            </div>

            <div class="mgt-16">
                <div class="t-subtitle2">
                    {{$t('908')}}
                    <!-- 강의 중복 수강신청 결정 전 다음 사항을 확인해주세요. -->
                </div>
                <div class="t-body3 mgt-10">
                    <div>
                        {{$t('909')}}
                        <!-- 1. 모든 학습 활동을 새롭게 시작하고 싶으신 경우 강의를 중복 수강신청 할 수 있습니다. -->
                    </div>
                    <div class="mgt-8">
                        {{$t('910')}}
                        <!-- 2. 강의 중복 수강신청 시 이전에 구매했던 강의 학습 정보는 유지되며, 새로운 학습이 시작되기 때문에 모든 학습 정보가 다시 시작됩니다. -->
                    </div>
                    <div class="mgt-8">
                        {{$t('911')}}
                        <!-- 3. 강의 중복 수강신청 완료 후 나의 학습 목록에서 여러 개의 동일한 강의가 보이며, 각각의 학습 화면으로 이동할 수 있습니다. -->
                    </div>
                </div>
            </div>

            <div class="mgt-16">
                <div>
                    <button class="mdc-button mdc-button--raised btn-red w-full btn-big" @click='moveInformation()'>
                        {{$t('912')}}
                        <!-- 강의 중복 {{paymentText}}하기 -->
                    </button>
                </div>
                <div class="mgt-16">
                    <button class="mdc-button mdc-button--raised btn-white w-full btn-big" @click='moveTotalDegree()'>
                        {{$t('913')}}
                    </button>
                </div>
            </div>
            
        </div>

        <div v-if="orderData.paymentPrice > 0">
            <div class="t-headline5 mgt-3">
                {{$t('438')}}
                <!-- 과거에 {{paymentText}}했던 강의입니다 -->
            </div>
            <div class="t-body3 mt6 t-color-content1">
                {{$t('439')}}
                <!-- 이미 동일한 강의를 {{paymentText}}하신 이력이 있습니다.<br> -->
                <br>
                {{$t('440')}}
                <!-- {{paymentText}} 내역은 아래와 같습니다. -->
            </div>

            <div class="mdc-card mdc-elevation--z3 mgt-16">
                <div class="t-subtitle2 pdt-16 pdl-16 pdr-16">
                    {{$t('441')}}
                    <!-- 과거 {{paymentText}}한 강의 정보 -->
                </div>

                <div v-for="(purchased, index) in purchasedData" :key="index">
                    <div class="pda-default">
                        <div class="t-body3">
                            <div class="t-color-content1">
                                {{$t('442')}}
                                <!-- 강의명 -->
                            </div>
                            <div>{{orderData.goods.name}}</div>
                        </div>
                        <div class="t-body3 mgt-17">
                            <div class="t-color-content1">
                                {{$t('443')}}
                                <!-- {{paymentText}} 일자 -->
                            </div>
                            <div>{{$moment(purchased.orderDate).format('L')}}</div>
                        </div>
                        <div class="t-body3 mgt-17">
                            <div class="t-color-content1">
                                {{$t('907')}}
                                <!-- 최종 학습 진도율 -->
                            </div>
                            <div class="text-title">To-Do%</div>
                        </div>
                    </div>
                    <div v-if="purchasedData.length-1 > index"><hr class="divider"></div>
                    

                    
                    <!-- <div class="t-body3 mt16">
                        <div class="t-color-content1">
                            {{$t('907')}}
                            최종 학습 진도율
                        </div>
                        <div class="text-title">To-Do%</div>
                    </div>
                    <div class="mt16" v-if="purchasedData.length-1 > index"><hr class="divider"></div> -->
                </div>
            </div>
            <div class="mgt-16">
                <div class="t-subtitle2">
                    {{$t('445')}}
                    <!-- 강의 중복 수강신청 결정 전 다음 사항을 확인해주세요. -->
                </div>
                <div class="t-body3 mgt-10">
                    <div>
                        {{$t('446')}}
                        <!-- 1. 모든 학습 활동을 새롭게 시작하고 싶으신 경우 강의를 중복 수강신청 할 수 있습니다. -->
                    </div>
                    <div class="mgt-8">
                        {{$t('447')}}
                        <!-- 2. 강의 중복 수강신청 시 이전에 구매했던 강의 학습 정보는 유지되며, 새로운 학습이 시작되기 때문에 모든 학습 정보가 다시 시작됩니다. -->
                    </div>
                    <div class="mgt-8">
                        {{$t('448')}}
                        <!-- 3. 강의 중복 수강신청 완료 후 나의 학습 목록에서 여러 개의 동일한 강의가 보이며, 각각의 학습 화면으로 이동할 수 있습니다. -->
                    </div>
                </div>
            </div>

            <div class="mgt-16">
                <div>
                    <button class="mdc-button mdc-button--raised btn-red w-full btn-big" @click='moveInformation()'>
                        {{$t('449')}}
                        <!-- 강의 중복 {{paymentText}}하기 -->
                    </button>
                </div>
                <div class="mgt-16">
                    <button class="mdc-button mdc-button--raised btn-white w-full btn-big" @click='moveTotalDegree()'>
                        {{$t('450')}}
                    </button>
                </div>
            </div>
        </div>


        
        
    </section>
</template>

<script>
/**
 * 구매하기 - 중복 구매/신청 컴포넌트(sales - Duplicate purchase / enrollment component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import salesApi from '@/api/salesApi.js'

export default {
    data() {
        return {
            orderData: {},
            purchasedData: [],
            paymentText: ''
        }
    },
    mounted() {
        document.documentElement.style.overflow = 'auto'
        window.onscroll = null
        this.fetchData()
    },
    
    methods: {
        fetchData() {
            let params = this.setParams()
            
            // get sales goods information
            salesApi.salesGoodsOrder(params).then((response) => {
                this.orderData = response.data.data
                let headerTitle = this.orderData.paymentPrice ? this.$t('437') : this.$t('900') // 구매 / 수강신청
                
                this.$parent.setTopAppBarCustom({
                    leftBtnMode: 'close',
                    rightBtnMode: '',
                    title: headerTitle,
                    leftBtnMethod: () => {
                        this.$router.go(-1)
                    },
                    rightBtnMethod: '',
                })
                
            }).catch((err) => {})

            // 중복 구매 목록(get Duplicate purchase list)
            salesApi.salesGoodsPurchased(params).then((response) => {
                this.purchasedData = response.data.data
            }).catch((err) => {})
        },

        // 파라미터 설정(set parameter)
        setParams() {
            let params = {
                goodsId: this.$route.params.goodsid
            }
            return params
            
        },
        
        // 결제 취소(move prev page)
        moveTotalDegree() {
            this.$router.go(-1)
        },

        // 상품 정보 화면으로 이동(move sales information)
        moveInformation() {
            this.$router.push({
                name:'SalesInformation', 
                params: {goodsid: this.$route.params.goodsid}
            })
        }
        
    }

}
</script>